import React from 'react';
import { IIconProps } from './utils';

export const ArrowLeft = ({
  fill = 'currentColor', height = 21, width = 21, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 16 16"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M7.99922 12.6654L3.33301 7.99922L7.99922 3.33301"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3332"
    />
    <path
      d="M12.6654 7.99902H3.33301"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3332"
    />
  </svg>
);
